/**
 * 策划中心-实时线索-计划线索-监测跟踪-左侧导航
 * 2019-06-18
 * Qian.qianchen
 */
'use strict';
angular.module('tracingMonitoringLeftModule', []).directive('tracingMonitoringLeft', [
    '$state',
    '$timeout',
    '$q',
    'trsHttpService',
    'tracingMonitoringService',
    'modalDialog',
    function($state, $timeout, $q, trsHttpService, tracingMonitoringService, modalDialog) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: './planningCenter/realTimeClues/plannedClues/tracingMonitoring/left/left_tpl.html',
            scope: {
                selected: '=',
                selectedItem: '=',
                selectedLeve3: '=',
            },
            link: function(scope, $elem, $attrs) {
                initStatus();
                getTrackLists().then(() => {
                    autoLocation();
                });

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.status = {
                        expanded: true,
                        trackLimit: 10,
                    };
                    scope.data = {
                        trackList: [],
                        trackid: null,
                    };
                }

                /**
                 * [autoLocation description] 自动定位
                 * @return {[type]} [description]
                 */
                function autoLocation() {
                    scope.$watch('selected', (newV, oldV) => {
                        if (newV === 'realtimeclues') {
                            scope.status.expanded = true;
                            let routerName = $state.current.name;
                            let routerArray = routerName.split('.');
                            let trackid = $state.params.trackid;
                            if ($state.params.trackid) {
                                scope.selectedItem = routerArray[3];
                                scope.selectedLeve3 = $state.params.trackid;
                            }
                        } else {
                            scope.selectedLeve3 = '';
                            scope.selectedItem = '';
                        }
                    });
                }

                /**
                 * [getAssignmentRights description] 获取监测列表
                 * @return {[type]} [description]
                 */
                function getTrackLists() {
                    let defer = $q.defer();
                    defer.resolve();
                    // let params = {
                    //     serviceid: 'monitortrack',
                    //     modelid: 'getTrackList',
                    // };
                    // scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                    //     scope.data.trackList = data;
                    //     defer.resolve();
                    // });
                    return defer.promise;
                }

                /**
                 * [deleteTrack description] 删除监测跟踪
                 * @param  {[type]} trackid [description] 监测跟踪id
                 * @return {[type]}         [description]
                 */
                function deleteTrack(trackid) {
                    let defer = $q.defer();
                    let params = {
                        id: trackid,
                        serviceid: 'monitortrack',
                        modelid: 'delTrack',
                    };
                    scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'get').then(function(data) {
                        modalDialog.alertType('', '删除成功', 'error', false);
                        defer.resolve();
                    });
                    return defer.promise;
                }

                /**
                 * [expandLeve2 description] 展开二级
                 * @param  {[type]} type [description] 类型名称
                 * @return {[type]}      [description]
                 */
                scope.expandLeve = function($event) {
                    // scope.status.expandedLeve2 = type;
                    let routerName = $state.current.name;
                    let routerArray = routerName.split('.');
                    if (routerArray[4] == 'tracingmonitoring') {
                        scope.status.expanded = !scope.status.expanded;
                        return;
                    }
                    $timeout(() => {
                        $($event.currentTarget)
                            .next('ul')
                            .find('a')[0]
                            .click();
                        scope.$root.narrowNavigation = false;
                    });
                };

                /**
                 * [selectLeve3 description] 选中三级
                 * @param  {[type]} routerNamePart [description] 路由名称
                 * @return {[type]}            [description]
                 */
                scope.selectLeve2 = function(track) {
                    let routerName = 'front.plan.realtimeclues.plannedclues.tracingmonitoring';
                    $state.go(routerName, { trackid: track.ID, trackname: track.TITLE }, { reload: routerName });
                    scope.selectedLeve3 = track.ID;
                    angular.$digest();
                    // if (scope.selected !== "plannedclues.tracingmonitoring") {
                    //     $timeout(() => {
                    //         scope.selected = "plannedclues.tracingmonitoring";
                    //     }, 500);
                    // }
                    if (scope.selected !== 'realtimeclues') {
                        $timeout(() => {
                            scope.selected = 'realtimeclues';
                        }, 500);
                    }
                };

                /**
                 * [addtrack description] 新建监测跟踪
                 * @param  {[type]} ev [description]
                 * @return {[type]}    [description]
                 */
                scope.addtrack = function(ev) {
                    ev.stopPropagation();
                    if (scope.data.trackList.length >= scope.status.trackLimit) {
                        modalDialog.alertType('', '监测数量超过上限，请先删除其他监控或联系租户管理员添加', 'warning', false);
                        return;
                    }
                    tracingMonitoringService.editTrack().then(() => {
                        getTrackLists().then(() => {
                            autoLocation();
                            createCallBack();
                        });
                    });
                };

                /**
                 * [editTrack description] 信息编辑
                 * @param  {[type]} nav [description]
                 * @return {[type]}     [description]
                 */
                scope.editTrack = function(nav) {
                    tracingMonitoringService.editTrack(nav.ID).then(() => {
                        getTrackLists().then(() => {
                            autoLocation();
                            editCallBack();
                        });
                    });
                };

                /**
                 * [deleteTrack description] 删除监测跟踪
                 * @param  {[type]} nav [description]
                 * @return {[type]}     [description]
                 */
                scope.deleteTrack = function(nav) {
                    if (angular.isUndefined(nav)) {
                        modalDialog.alertType('', '请选择监测跟踪', 'error', false);
                        return;
                    }
                    modalDialog.confirmModal('', '当前监测跟踪删除后不可恢复，确定继续？', function() {
                        deleteTrack(nav.ID).then(() => {
                            getTrackLists().then(() => {
                                autoLocation();
                                deleteCallBack();
                            });
                        });
                    });
                };

                /**
                 * 计算当前选中li,返回trackList中的数据
                 * @param  [description]
                 * @return {[type]} [description]
                 */
                function countLi(edit, create, del) {
                    var trackList = scope.data.trackList,
                        trackid = scope.selectedLeve3,
                        trackItem,
                        trackIndex;
                    trackList.forEach((item, index) => {
                        if (item.ID == trackid) {
                            trackItem = item;
                            trackIndex = index;
                        }
                    });
                    if (edit == 'edit') {
                        // 修改
                        return trackItem;
                    } else if (create == 'create') {
                        // 新建
                        if (trackList.length == 1) {
                            return trackList[0];
                        }
                    } else if (del == 'del') {
                        // 删除
                        // 是否全部删除
                        if (trackList.length > 0) {
                            // 当前选中的被删除
                            if (trackIndex == undefined) {
                                return trackList[0];
                            } else {
                                return null; // 不用管
                            }
                        } else {
                            return 0; // 0 数据全部被删除
                        }
                    }
                }

                /**
                 * 编辑后，模拟点击，更新数据
                 * @param  [description]
                 * @return {[type]} [description]
                 */
                function editCallBack() {
                    var trackItem = countLi('edit', null, null);
                    scope.selectLeve2(trackItem);
                }

                /**
                 * 删除后，显示第一个列表的信息，如果没有数据了，返回plan
                 * @param  [description]
                 * @return {[type]} [description]
                 */
                function deleteCallBack() {
                    var trackItem = countLi(null, null, 'del');
                    if (trackItem == 0) {
                        var routerName = 'front.plan';
                        $state.go(routerName);
                    } else if (trackItem != null) {
                        scope.selectLeve2(trackItem);
                    } else {
                        return;
                    }
                }

                /**
                 * 第一次新建后，显示第一个列表的信息
                 * @param  [description]
                 * @return {[type]} [description]
                 */
                function createCallBack() {
                    var trackItem = countLi(null, 'create', null);
                    if (scope.data.trackList.length == 1) {
                        scope.selectLeve2(trackItem);
                    }
                }
            },
        };
    },
]);
